import React from "react";
import "./styles.css";

const CustomInput = ({ 
  placeholder,
  value,
  onChange,
  type = "text",
  disabled = false,
  size = "default",
  className = "",
  style = {},
  ...props
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`custom-input ${size} ${className}`}
      style={style}
      {...props}
    />
  );
};

export default CustomInput;
